{
    "workouts": {
        "labels": {
            "name": "Workout Title: ",
            "duration": "Duration: ",
            "xss": "XSS: ",
            "xep": "XEP: ",
            "fatcarbs": "Fat/Carbs:",
            "focus": "Focus: ",
            "difficulty_rating": "Difficulty: ",
            "specificity_rating": "Specificity: ",
            "source": "Source: ",
            "suitability": "Suitability: "
        },
        "search": {
            "filter_by_tag": "Filter by Tag",
            "keyword": "Search Workouts"
        },
        "alt": {
            "workout_thumb": "Workout titled {name}"
        }
    },
    "activity": {
        "group_members": "Group Members: "
    },
    "training": {
        "wait_exercises_first_load": "Calculating advice...",
        "wait_exercises": "Recalculating advice...",
        "indoor": "Workout",
        "outdoor": "Outdoor Ride",
        "virtual": "Virtual Ride",
        "all": "Exercise"
    },
    "forecast": {
        "forecast": "Forecast Training for next {weeks, plural, one {week} other {# weeks}}",
        "forecast_refresh": "Recalculate Training Forecast for next {weeks, plural, one {week} other {# weeks}}",
        "forecast_next_event": "Forecast Training until next \"A\" event",
        "forecast_refresh_next_event": "Recalculate Training Forecast until next \"A\" event",
        "forecast_clear": "Clear Training Forecast",
        "forecast_stop": "Stop Training Forecast",
        "adapt_failed_title": "No plan can reach your target",
        "adapt_failed_help": "Xert worked through your availability, intensity marks, recovery and training load limits and couldn't map out training that reaches your target. It first becomes impossible on the date shown, and the cause is often earlier in the plan, such as a recent activity or a change to an earlier day, rather than that day's own settings.",
        "adapt_failed_help_now": "Xert worked through your availability, intensity marks, recovery and training load limits and couldn't map out training that reaches your target. Your settings leave no workable plan starting from today, and the limiting factor could be on any upcoming day.",
        "adapt_failed_tip_availability_now": "Check availability and durations on your upcoming days. More availability or Flex gives the plan more room",
        "adapt_failed_tip_intensity_now": "Check High and Low intensity marks on your upcoming days, or change them to \"Low or High\"",
        "adapt_failed_tip_availability": "Check availability and durations on that day and the days leading up to it. More availability or Flex gives the plan more room",
        "adapt_failed_tip_intensity": "Change High or Low intensity marks on those days to \"Low or High\"",
        "adapt_failed_tip_target": "To change your targets, update your plan on the Program page",
        "adapt_failed_taper": "Xert worked through your availability and event settings and couldn't fit a taper week that gets you ready for your event.",
        "adapt_failed_tip_taper_availability": "Allow more availability or remove High/Low marks in the week before your event",
        "adapt_failed_tip_taper_length": "Reduce the taper length in your plan settings",
        "adapt_failed_tips_intro": "To make a plan possible, try one of these, then adapt again:",
        "adapt_warning_title": "Forecast adapted, but it doesn't reach your target",
        "adapt_warning_help": "Xert built the closest plan it could within your availability, intensity marks, recovery and training load limits, but the plan falls short of your target.",
        "adapt_warning_shortfall": "By your target date, the plan reaches:",
        "adapt_warning_tips_intro": "To get closer to your target, try one of these, then adapt again:",
        "adapt_warning_tip_availability": "Add available days or longer durations, or switch Fixed days to Flex",
        "adapt_warning_tip_hours": "Raise your Max Weekly Hours",
        "adapt_warning_hours_title": "Forecast adapted, but it goes over your Max Weekly Hours",
        "adapt_warning_hours_help": "Your availability and target needed more training time than your Max Weekly Hours allows, so Xert exceeded it in some weeks. Max Weekly Hours is a preference, not a hard limit.",
        "adapt_warning_hours_tips_intro": "To stay within your limit, try one of these, then adapt again:",
        "adapt_warning_hours_label": "Max Weekly Hours:",
        "adapt_warning_save": "You can still save this forecast as it is.",
        "adapt_failed_reasons": "What got in the way:",
        "constraints": {
            "unavailable": "Day is marked as unavailable",
            "low_post_event_recovery": "Event Readiness is not reached. Not enough Low Training Load",
            "high_post_event_recovery": "Event Readiness is not reached. Not enough High Training Load",
            "peak_post_event_recovery": "Event Readiness is not reached. Not enough Peak Training Load",
            "event_ltl_target": "Low Training Load will not reach the forecast target",
            "event_htl_target": "High Training Load will not reach the forecast target",
            "event_ptl_target": "Peak Training Load will not reach the forecast target",
            "median_duration_exceeded": "Estimated training time is more than your availability",
            "weekly_hours_exceeded": "Training this week is more than your Max Weekly Hours",
            "low_form": "Status is Very Tired. Training should be avoided",
            "high_form": "Status is Tired (high). High Intensity Training should be avoided",
            "peak_form": "Status is Tired (peak). High Intensity Training should be avoided",
            "low_recovery": "Too much low intensity XSS to recover in time",
            "high_recovery": "Too much high intensity XSS to recover in time",
            "peak_recovery": "Too much peak intensity XSS to recover in time",
            "intensity_unmet_short": "Intensity not scheduled",
            "intensity_high_unmet": "You asked for a high intensity day, but it couldn't be scheduled without conflicting with your other settings, such as recovery or training load targets. This day is a rest day instead",
            "intensity_low_unmet": "You asked for a low intensity day, but it couldn't be scheduled without conflicting with your other settings, such as recovery or training load targets. This day is a rest day instead"
        }
    },
    "sessions": {
        "alt": {
            "workout_thumb": "Workout chart for session {name}",
            "uploaded_image": "Uploaded image for session.",
            "user_avatar": "User profile picture of {name}"
        },
        "details": {
            "participants": "Participants"
        },
        "editor": {
            "new_session": "New Session",

            "create_session": "Create Template",
            "edit": "Edit Session",
            "details": "Session Details",
            "sharing": "Share Session",
            "share": "Share",
            "workout": "Workout List",
            "videos": "Media Configuration",
            "upload": "Upload Session Images",

            "group_members": "Participants",
            "invite_members": "Invite Members",

            "create": "Create",
            "update": "Save",
            "delete": "Delete",
            "cancel": "Cancel",
            "copy": "Copy",
            "next": "Next",
            "back": "Back",
            "tabs": {
                "details": "Details",
                "sharing": "Sharing",
                "workout": "Workout",
                "route": "Route",
                "media": "Media"
            },
            "image_name": "Image {i}",

            "labels": {
                "name": "Title",
                "description": "Description",
                "session_category": "Session Category",
                "community": "Community",
                "workout_name": "Workout",
                "route": "[TODO] Route",
                "duration": "Duration",
                "xss": "XSS",
                "start_date": "Activity Date",
                "start_time": "Activity Time",
                "repeat": "Repeat",
                "repeat-weekly": "Weekly",
                "repeat-weekly-2": "2 Week",
                "repeat-weekly-3": "3 Week",
                "repeat-weekly-4": "4 Week",
                "repeat-daily": "Daily",
                "repeat-none": "None",
                "tags": "Tags",
                "distance": "Distance",
                "focus": "Focus",
                "difficulty": "Difficulty Rating",
                "elevation": "Elevation",
                "specificity": "Specificity Rating",
                "training_status": "Training Status:",

                "duration_seconds": "Seconds",
                "duration_minutes": "Mins",
                "xss_points": "Points",
                "km": "km",
                "meters": "m",

                "session_type": "Session Type",
                "venue": "Venue:",
                "media_type": "Main Media Type:",

                "authorize_zoom": "Authorize Zoom",
                "why_authorize_zoom": "To enable meeting auto-creation, Zoom authorization is required",
                "deauthorize_zoom": "Deauthorize Zoom",
                "autocreate_zoom": "Auto-create Meeting:",
                "zoom_url": "Zoom Link:",
                "zoom_url_placeholder": "Paste Zoom Link Here",

                "zoom_url_recommendation_text": "We recommend the meeting has the following settings:",
                "zoom_url_recommendation_1": "Allow participants to join anytime",
                "zoom_url_recommendation_2": "Disable waiting room",
                "zoom_url_recommendation_more_info": "For more information, see",
                "zoom_url_recommendation_more_info_title": "Allow participants to join before host",

                "video": "YouTube Link:",
                "video_offset": "Video start offset:",
                "spotify_url": "Spotify Playlist:",

                "public": "Public",
                "invite-all": "All Members",
                "invite-only": "Invite Only",

                "youtube": "Youtube",
                "zoom": "Zoom",
                "spotify": "Spotify"
            }
        },
        "scheduler": {
            "details": "Scheduling Details",
            "schedule": "Schedule",
            "reschedule": "Save",
            "unschedule": "Delete",
            "error": "Problem with template id",
            "tabs": {
                "details": "Details",
                "sharing": "Sharing"
            }
        },
        "card": {
            "copy": "Copy",
            "scheduled_by": "Scheduled by: ",
            "schedule_session": "Schedule",
            "clear_workout": "Clear",
            "play_session": "Play Now",
            "open_remote_player": "Open Player",
            "edit_session": "Edit Session",
            "copy_session": "Copy Session",
            "share_session": "Share Session",
            "delete_session": "Delete Session",
            "workout_name": "Workout:",
            "specificity_rating": "Specificity:",
            "focus": "Focus:",
            "focus_suffix": "power",
            "xss": "XSS:",
            "difficulty": "Difficulty:",
            "fatcarbs": "Fat/Carbs:",
            "starts": "Starting",
            "started": "Remaining:",
            "already_ended": "Session Ended",
            "ending": "Ending",
            "duration": "Duration:",
            "distance": "Distance:",
            "suitability": "Suitability:",
            "training_surplus": "Training Surplus after completing:",
            "training_deficit": "Training Deficit after completing:",
            "additional_members": "Riders",
            "zoom": "Zoom"
        },
        "browser": {
            "sessionslibrary": "Sessions Library",
            "sessionsscheduled": "Scheduled Sessions",
            "personal": "Personal",
            "community": "Community",
            "standard": "Standard",
            "upcoming": "Upcoming",
            "recent": "Recent",
            "archived": "Archived",
            "join": "Join Session",
            "join_in_progress": "Join In Progress",
            "join_short": "Join",
            "open_remote_player": "Open Player",
            "open_short": "Open",
            "already_joined": "Joined",
            "leave": "Leave",
            "today": "Today",
            "tomorrow": "Tomorrow",
            "this_week": "This Week",
            "group_training_communities": "Group Training Community",
            "retry": "Retry"
        },
        "group_picker": {
            "title": "Join Group Training",
            "description": "Select a group training community to join below",
            "select_time": "Select a time",
            "schedule": "Schedule",
            "join": "Join"
        },
        "errors": {
            "no_session": "ERROR: No session object set for editing.",
            "required_input": "Please fill out this field.",
            "invalid_input": "Invalid format."
        },
        "tags": {
            "public": "Public",
            "intense": "Intense",
            "uphill": "Uphill",
            "todo": "TODO: Add more tags",
            "daily": "Daily",
            "weekly": "Weekly"
        }
    },
    "duration": {
        "seconds": "{seconds} s",
        "minutes": "{minutes} min",
        "hours": "{hours} hours",
        "hours_and_minutes": "{hours, plural, one {# hour} other {# hours}}{minutes, plural, =0{} one { # min} other { # mins}}"
    },
    "time": {
        "seconds": "In {seconds} seconds",
        "minutes": "In {minutes} minutes",
        "hours": "In {hours} hours {minutes} minutes",
        "hour_singular": "In 1 hour {minutes} minutes",
        "today_at": "Today at {time}",
        "tomorrow_at": "Tomorrow at {time}",
        "today": "Today",
        "tomorrow": "Tomorrow",
        "date_at": "{date} at {time}"
    },
    "clubs": {
        "club": "Club",
        "squad": "Squad",
        "coach": "Coach",
        "team": "Team"
    },
    "calendar": {
        "availability": {
            "available": "Available",
            "unavailable": "Unavailable"
        },
        "venue": {
            "advisor": "Use Advisor",
            "indoor_workout": "Indoor Workout",
            "virtual_ride": "Indoor Virtual Ride",
            "outdoor_workout": "Outdoor Workout",
            "outdoor_ride": "Outdoor Ride"
        },
        "time": {
            "advisor": "Median",
            "morning": "Morning\n7:00am",
            "afternoon": "Afternoon\n1:00pm",
            "evening": "Evening\n7:00pm",
            "custom": "Custom"
        },
        "duration": {
            "advisor": "Median",
            "one_hour": "1 hour",
            "one_hour_thirty_min": "1 hour 30 mins",
            "two_hour": "2 hours",
            "custom": "Custom"
        },
        "sport_actions": "{past, select, true {Add} other {Plan}} {sport_type, select, Cycling {a Ride} Running {a Run} other {an Activity}}"
    },
    "focus" : {
        "power sprinter": {
            "description": "Focus on all-out sprints",
            "minute_power": 2
        },
        "road sprinter": {
            "description": "Focus on all-out sprints",
            "minute_power": 2
        },
        "pursuiter": {
            "description": "Focus on short very hard efforts",
            "minute_power": 3
        },
        "puncheur": {
            "description": "Focus on short punchy power efforts",
            "minute_power": 4
        },
        "breakaway specialist": {
            "description": "Focus on attacking with strong power efforts",
            "minute_power": 5
        },
        "rouleur": {
            "description": "Focus on strong hard pulls",
            "minute_power": 6
        },
        "gc specialist": {
            "description": "Focus on efforts well above threshold",
            "minute_power": 8
        },
        "climber": {
            "description": "Focus on efforts above threshold",
            "minute_power": 10
        },
        "sprint time-triallist": {
            "description": "Focus on efforts slightly above threshold",
            "minute_power": 20
        },
        "endurance": {
            "description": "Focus on efforts near your lower threshold power",
            "endurance_alt_description": "Focus on efforts near or just below lower threshold power",
            "minute_power": null
        },
        "triathlete": {
            "description": "Focus on efforts near your lower threshold power",
            "endurance_alt_description": "Focus on efforts near or just below lower threshold power",
            "minute_power": null
        },
        "long sprinter": {
            "description": "Focus on 400m sprint pace",
            "minute_power": 1,
            "running": true
        },
        "long distance": {
            "description": "Focus on 10k pace intervals",
            "minute_power": 45,
            "running": true
        },
        "short middle distance": {
            "description": "Focus on 1500m pace intervals",
            "minute_power": 5,
            "running": true
        },
        "middle distance": {
            "description": "Focus on 5000m pace intervals",
            "minute_power": 15,
            "running": true
        }
    },
    "specificity_rating": {
        "pure": {
            "label": "Pure",
            "description": "with light pedaling rest in between"
        },
        "mixed": {
            "label": "Mixed",
            "description": "with medium effort rest intervals in between"
        },
        "polar": {
            "label": "Polarized",
            "description": "while pushing longer endurance efforts in between"
        }
    },
    "specificity_rating_running": {
        "pure": {
            "label": "Pure",
            "description": "with light jogging rest in between"
        },
        "mixed": {
            "label": "Mixed",
            "description": "with medium jog rest intervals in between"
        },
        "polar": {
            "label": "Polarized",
            "description": "while pushing longer tempo efforts in between"
        }
    },
    "forecast_descriptions": {
        "rest" : {
            "main" : "Consider doing other activities.",
            "many_weeks": "You don't need to train today in order to meet your goals but it should be okay to train if you have time available.  Get ahead of your plan by doing some training but pay attention to when your next high intensity day is scheduled.  Be sure not to get too tired for that.",
            "last_2_weeks": "Your event is coming up so be sure keep to your schedule."
        },
        "recovery": "Try and get a bit more sleep and avoid any strenous activities. Give your body time to recover so that you can continue to make quality gains in fitness.  If you wish, feel free to do a light and easy 30 minutes of active recovery.",
        "low_intensity": {
            "main": "You should ride easy to complete the required training. This is often called \"LSD\" or \"Long Slow Distance\".  Others call it Zone 2 training.  The goal of this training is to ride easy and long enough to put strain on your low intensity energy system and avoid putting strain on your high and peak intensity systems.  This helps improve the body's aerobic/oxidative energy capacity which translate to improving your ability to use fat to supply energy to the working muscles.  This increases your threshold power and also increases your ability to go longer distances without getting tired.",
            "no_taper_next_high_far": "Your next High Intensity training is at least {polarizationLevel} days away so you're okay to add a bit of high intensity to your training. But don't over do it otherwise the quality of your upcoming high intensity training may be affected.",
            "no_taper_next_high_close": "Your next High Intensity training is only {daysToHI} days away so keep your intensity in check the whole time today.",
            "tmrw_recovery": "Note that today is going leave you very tired.  If you can be disciplined and maintain low intensity throughout the training, you should not feel too hungry afterwards.  Review the carb requirements of the training you choose and be sure to replenish them during your training and eat normally afterwards with some additional protein to aid in recovery. Feel free to use baths, massage or compression but avoid taking painkillers as they can interrupt the gains you'll be making during recovery."
        },
        "2nd_last_week": "Your taper week is coming soon.  Stay committed to your training in preparation.",
        "last_week": "You are in your taper week.  Follow the plan precisely.  Eat well and give yourself the needed rest in preparation for the event.",
        "road_sprinter": {
            "label": "Road Sprinter",
            "main": "This training is designed to improve your top end power.  Both your peak and high intensity energy systems will see improvement.  Your training will include all-out intervals of 60 seconds or less.",
            "cycling": "You should stand for each interval, keeping your cadence high and legs moving quickly.",
            "zone_info": "Upper 6/7 - Anaerobic/Neuromuscular."
        },
        "pursuiter": {
            "label": "Pursuiter",
            "main": "During this training, you'll be working your ability to go fast.  Your peak intensity system will get you to accelerate and your high intensity system will keep you moving faster and faster.  You should focus on hard efforts, picking up lots of speed and maintaining this speed on each interval.",
            "cycling": "You should rev up your cadence quite high during each acceleration and keeping the legs moving very quickly while seated.",
            "zone_info": "6 - Anaerobic."
        },
        "puncheur": {
            "label": "Puncheur",
            "main": "Your focus is on punchy accelerations which will improve your ability to tackle shorter hills.  Focus on pushing hard while standing.  You should feel out of breath at the end of each set but not totally gasping for air.",
            "cycling": "Alternate between staying seated and standing, with cadence being a bit faster than normal.",
            "zone_info": "Upper 5 / 6 - VO2Max to Anaerobic."
        },
        "breakaway_specialist": {
            "label": "Breakaway Specialist",
            "main": "You're going to practice on the power needed to get away and stay away from the pack.  Focus on maintaining the hardest effort that you can sustain.  You should be breathing harder and harder as you do these intervals, as it is meant to elicit VO2max or close to it.",
            "cycling": "Stay seated and don't let your legs slow down.",
            "zone_info": "5 / Lower 6 - VO2Max to Anaerobic."
        },
        "rouleur" :{
            "label": "Rouleur",
            "main": "You're going to concentrate on manageable power to keep the pace high.  Focus on maintaining a power you could hold for many minutes.  With each repetition, your breathing should be increasing towards its max.",
            "cycling": "Stay seated and keep a good strong cadence during each interval.",
            "zone_info": "5 - VO2Max."
        },
        "gc_specialist": {
            "label": "GC Specialist",
            "main": "The steadier efforts in this training help you become an all-round athlete.  Focus on efforts just above your threshold.",
            "cycling": "Your cadence should be constant and comfortable.  It should not feel fast or slow.",
            "zone_info": "Upper 4 / 5 - Lactate Threshold to VO2Max."
        },
        "climber": {
            "label": "Climber",
            "main": "You're going to practice sustainable power to improve your performance on long mountain climbs.  You should focus on efforts near your threshold.",
            "cycling": "Combine both seated and out-of-the-saddle efforts to maintain comfort during these threshold intensity intervals.  Your cadence should be comfortable and not feel fast or slow when seated or standing.",
            "zone_info": "4 - Lactate Threshold."
        },
        "endurance": {
            "label": "Endurance",
            "low_intensity": {
                "main": "You're going focus on improving your aerobic power. You should look to maintain efforts near your Lower Threshold Power.",
                "zone_info": "2 - Endurance."
            },
            "high_intensity": {
                "main": "You're going focus on improving your threshold power.",
                "zone_info": "Upper 3 / 4 - Tempo to Lactate Threshold."
            }
        },
        "pure": "Focus on keeping your recovery intervals very easy,  perhaps stopped or coasting even.  Very easy recovery intervals allow you to recover from the high intensity intervals more quickly, allowing you to do more of them and put more strain on high and peak energy systems.",
        "mixed": "Focus on alternating your rest intervals with some easy and some at higher intensities near your lower threshold power ({LTP} watts).  This ensures you get a good mix of strain against each energy producing system.",
        "polar": "Focus on maintaining a higher power near your lower threshold power ({LTP} watts) between intervals.  This promotes your ability recover under fatigue, boosting your threshold power, lifting your low intensity energy system's aerobic capacity and increasing the ability to use lactate as a fuel.  The rest intervals are longer, reducing the number of high intensity intervals you can do.",
        "high_intensity": {
            "challenging": "You will challenged so be sure to be well-rested beforehand, fuel up and hydrate beforehand and maintain your carb intake and hydration during your training.  Stay focused and motivated.  It'll be worth it.",
            "not_challenging": "Your efforts will need good concentration.  Fuel up and stay hydrated the whole time.",
            "tmrw_recovery": "Note that this training will be very taxing on your body.  Be sure to replenish your muscle glycogen stores afterwards by eating carbohydrates during recovery.  Also be sure to consume water with your carbohydrates as this is needed for muscle glycogen storage.  Add additional protein to your meals to aid in muscle repair and recovery.  Feel free to use baths, massage or compression but avoid taking painkillers as they can interrupt the gains you'll be making during recovery."
        },
        "tmrw_rest_no_taper": "It's okay to do a bit more if you have time. You have extra time to rest before your next training session."
    },
    "report": {
        "program": {
            "GOAL": "Goal",
            "EVENT": "Event",
            "RACE": "Race"
        },
        "hero": {
            "pill": {
                "ORIGINAL_ACHIEVED": "Original goal achieved",
                "ADJUSTED_ACHIEVED": "Adjusted goal achieved",
                "NOT_ACHIEVED": "Goal not reached",
                "INCOMPLETE": "Assessment incomplete",
                "STATUS_ON_TRACK": "On track",
                "STATUS_BEHIND": "Behind your plan",
                "STATUS_AT_RISK": "Plan ends short of the goal",
                "STATUS_UNKNOWN": "In progress"
            },
            "focus_power": "{duration} power",
            "race_completed": "Race completed",
            "event_completed": "Event completed",
            "title": {
                "status": "Forecast AI Plan Status",
                "report": "Forecast AI Training Report"
            },
            "predictive_on": "Predictive Mode",
            "predictive_was": "Was in Predictive Mode",
            "your_goal": "Your goal:",
            "weeks": "{count} weeks",
            "target_date": "Target date {date}",
            "as_of": "As of {date}",
            "days_to_go": "{count} days to go",
            "not_reached": "Not reached: {measure}",
            "breakthrough_in_race": "★ Breakthrough in the race",
            "predicted_at_race": "Signature as predicted at the race",
            "event_readiness": "Event Readiness",
            "targets_reached": "{reached} of {total} targets reached",
            "now": "now",
            "at_the_end": "at the end",
            "plan_ends_at": "plan ends at {value}",
            "goal_value": "goal {value}",
            "distance_km": "{value} km"
        },
        "table": {
            "measure": "Measure",
            "now": "Now",
            "target": "Target",
            "actual": "Actual",
            "on_track": "On track",
            "reached": "Reached",
            "not_recorded": "The targets of this plan were not recorded.",
            "adapt": "Adapt Forecast",
            "power_capability": "Power capability",
            "not_assessed": "Not assessed: no target signature was stored for this plan.",
            "load_readiness": "Training-load readiness"
        },
        "overview": {
            "where_today": "Where you are today",
            "goal_result": "Goal result",
            "targets": "Targets",
            "projection_intro": "The plan as last saved, projected to the target date. Adapt your forecast to bring it up to date with your training.",
            "def_now": "is where your training has taken you so far.",
            "def_target": "is what your plan aims for by the target date. Adapting your forecast keeps aiming for it.",
            "projected": "Projected",
            "def_projected": "is where the plan, as last saved, is expected to end up. It can be above or below your target, and it moves when you adapt your forecast.",
            "after_adapted": "After the plan was adapted",
            "race_day": "Race day",
            "event_day": "Event day",
            "training_so_far": "Your training so far",
            "still_ahead": "Still ahead: {days} training days · Low {low} · High {high} · Peak {peak} XSS.",
            "signature": "Signature",
            "start": "Start",
            "predicted_today": "Plan predicted for today",
            "consistency": "Training consistency",
            "signature_so_far": "Fitness Signature so far",
            "signature_change": "Fitness Signature change",
            "tp": "Threshold Power",
            "hie": "High Intensity Energy",
            "pp": "Peak Power",
            "load_so_far": "Training load so far",
            "load_change": "Training load change",
            "achieved": "Achieved",
            "power_curve": "Power duration curve",
            "end": "End",
            "curve_needs": "The athlete's signature at the start and the end is needed for the curve.",
            "focus_settings": "Your focus settings",
            "plan_settings": "Your plan settings",
            "consistency_calendar": "Training consistency calendar",
            "load_through": "Training load through the plan",
            "takeaways": "Key takeaways"
        },
        "race": {
            "at_race": "At the race",
            "breakthrough_before": "★ Breakthrough in the race. Before it:",
            "no_breakthrough": "No breakthrough in the race: the signature is the one predicted for the race day."
        },
        "readiness": {
            "heading": "Event readiness",
            "result": "Result",
            "name": "Event Readiness",
            "by_load": "By load: Low {low}, High {high}, Peak {peak}"
        },
        "progress": {
            "goal": "goal {value}",
            "goal_title": "Goal",
            "of_the_way": "{percent}% of the way to the goal"
        },
        "focus": {
            "minutes": "{n, plural, one {# minute} other {# minutes}}",
            "seconds": "{n} seconds",
            "min_sec": "{time} minutes",
            "focus": "Focus",
            "target_duration": "Target duration",
            "goal_above": "Goal above your start",
            "specificity": "Specificity",
            "max_hours": "Max weekly hours",
            "hours": "{n} hrs",
            "not_recorded": "The plan's settings were not recorded."
        },
        "load": {
            "total": "Total Load",
            "low": "Low Load",
            "high": "High Load",
            "peak": "Peak Load"
        },
        "consistency": {
            "on_target": "On target",
            "close": "Close",
            "far_off": "Far off target",
            "aria": "{percent}% of training days on or near target",
            "on_or_near": "On or near target days",
            "of": "{n} of {total}",
            "of_so_far": "{n} of {total} so far",
            "how_judged": "A day is judged by the worst of its Low, High and Peak XSS against what was prescribed. Doing much more than prescribed counts as off target too.",
            "none": "No prescribed training days yet."
        },
        "takeaways": {
            "none": "Nothing to summarise yet."
        },
        "result": {
            "intro_race": "The activity recorded on race day. Whether you reached the modeled capability and training loads is shown separately above.",
            "intro_event": "The activity recorded on event day. Whether your training loads were ready is shown separately above.",
            "activity": "Activity",
            "distance": "Distance",
            "moving_time": "Moving time",
            "elapsed_time": "Elapsed time",
            "elevation": "Elevation gain",
            "avg_speed": "Average speed",
            "avg_power": "Average power",
            "xss": "XSS",
            "view_race": "View race activity",
            "view_event": "View event activity",
            "others": "{others, plural, one {# other activity} other {# other activities}} that day; this one was chosen as the {kind, select, RACE {race} other {event}} because {method, select, matched_to_event {it was matched to the planned activity} closest_start {it started closest to the planned time} other {it was the only one}}.",
            "too_short": "An activity was recorded that day, but none was long enough to count as the {kind, select, RACE {race} other {event}}.",
            "none": "No activity was recorded for the day."
        },
        "weeks": {
            "mon": "Mon",
            "tue": "Tue",
            "wed": "Wed",
            "thu": "Thu",
            "fri": "Fri",
            "sat": "Sat",
            "sun": "Sun",
            "week": "Week {n}",
            "day_label": "{date}: overall {overall}, Low {low}, High {high}, Peak {peak}",
            "rest": "Rest day",
            "rest_trained": "Rest day with training",
            "rings": "The four rings of a day: the day overall, Low, High and Peak."
        },
        "progress_tab": {
            "so_far": "Fitness so far",
            "progress": "Fitness progress",
            "from": "{change} from {start}",
            "dashed": "The dashed grey line is what your plan predicted. When a plan is updated it is recalculated from where you actually are, so the prediction steps to your current fitness on that day.",
            "power_goal": "Your {duration} power goal",
            "goal_line_now": "Start {start} W · now {finish} W · plan predicted {predicted} W · target {target} W.",
            "goal_line_finish": "Start {start} W · finish {finish} W · plan predicted {predicted} W · target {target} W."
        },
        "execution": {
            "heading": "Your training: completed and prescribed",
            "intensity_low": "Low intensity",
            "intensity_high": "High intensity",
            "intensity_peak": "Peak intensity",
            "of_xss": "{actual} of {prescribed} XSS · {percent}%",
            "completed": "You completed {onTarget} of your {days} training days right on target{close, plural, =0 {} other {, and # close to it}}.",
            "rest_kept": "You kept {kept} of {days} rest days.",
            "off_plan": "You also did {n, plural, one {# activity} other {# activities}} outside the plan.",
            "unplanned": "Training on days or at intensities the plan did not prescribe: Low {low} · High {high} · Peak {peak} XSS.",
            "hours": "Training time in the plan: {n} hours.",
            "circles": "Circle colours judge each of Low, High and Peak against what was prescribed for the day. Doing much more than prescribed counts as off target, as doing much less does."
        },
        "journey": {
            "heading": "Where your plan said you would end up",
            "intro": "Each point is a version of your plan, in the order it was saved, and what it predicted for the end.",
            "moved": "The target date moved, so each target date has its own line.",
            "saved_once": "This plan was saved once, so there is one forecast to show.",
            "replaced": "When a plan is updated (Update existing plan or Adapt Forecast) its forecast is replaced in place and the earlier one is not kept; where that happened is marked on the Your Progress chart."
        },
        "versions": {
            "heading": "Versions of your plan",
            "intro": "What each version of the plan predicted for the target date",
            "as_updated": ", as last updated",
            "version": "Version",
            "saved": "Saved",
            "target_date": "Target date",
            "changed": "How the plan changed",
            "no_other": "No other version of the plan was saved, so the earlier forecast is not kept.",
            "no_change": "No change to what the plan predicted for the end.",
            "updated_from": "Updated from where you were on {dates}: the prediction restarted from your actual fitness on those days.",
            "keeps": "Forecast AI keeps what each version predicted. It does not keep why a plan was saved again, so none is given."
        },
        "breakthroughs": {
            "flagged": "Flagged. Your signature is being recalculated from that activity forward; this page updates when it is done.",
            "unflagged": "Unflagged. Your signature is being recalculated from that activity forward; this page updates when it is done.",
            "flag_failed": "The activity could not be flagged.",
            "unflag_failed": "The activity could not be unflagged.",
            "heading": "Breakthroughs",
            "none": "No breakthroughs during this plan.",
            "date": "Date",
            "flag": "Flag",
            "down_3": "Down more than 3%",
            "vs_plan": "{change} vs plan",
            "flagged_title": "Flagged: click to unflag",
            "flag_this": "Flag this activity",
            "unflag_this": "Unflag this activity",
            "this_activity": "this activity",
            "confirm_unflag": "Unflagging {name} puts it back in your fitness analysis.",
            "confirm_flag": "Flagging {name} takes it out of your fitness analysis.",
            "confirm_tail": "Your signature changes from that activity forward as your history is recalculated.",
            "working": "Working…",
            "unflag_it": "Unflag it",
            "flag_it": "Flag it",
            "cancel": "Cancel",
            "note_a": "A breakthrough in one measure can lower another; a change shown in",
            "red": "red",
            "note_b": "is a drop of more than 3% from the value before that activity. Consider flagging these activities. The small figure under each change is how it compares with what the plan predicted. Flag an activity you do not want to count; flagged activities stay in the list with a red flag, and unflagging puts one back."
        },
        "mark": {
            "close": "Close to the target",
            "miss": "Not reached",
            "short": "Short of the target",
            "unknown": "Not known"
        },
        "share": {
            "rebuild_title": "Recalculate this report from your history as it is now",
            "rebuilding": "Rebuilding…",
            "rebuild": "Rebuild",
            "preparing": "Preparing PDF…",
            "download": "Download PDF",
            "rebuilt": "Rebuilt from your history as it is now.",
            "rebuild_failed": "The report could not be rebuilt. Please try again.",
            "pdf_failed": "The PDF could not be prepared. Please try again."
        },
        "calendar": {
            "completed": "Completed",
            "forecasted": "Forecasted",
            "rest": "Rest",
            "thirds": "The circle is split in thirds: Low, High and Peak XSS against what was prescribed.",
            "on_target": "on target",
            "close": "close",
            "far_off": "far off target",
            "click": "Click a day for the numbers."
        },
        "predictive": {
            "an_activity": "An activity",
            "on_date": "on {date}",
            "tip": "{who} shows you are performing better than your plan assumed. Apply to my plan adjusts your plan with new targets. This changes your fitness history from the first activity of this plan, and some breakthroughs may no longer count as breakthroughs. Click for the details.",
            "failed": "The plan could not be adjusted.",
            "now_follows": "Your plan now follows your predicted fitness.",
            "recalculating": "Your fitness history is being recalculated, which can take a minute.",
            "heading": "You had a breakthrough",
            "shows": "{who} shows you are performing better than your plan assumed.",
            "applying": "Applying it adjusts your plan with new targets.",
            "applying_busy": "Applying…",
            "apply": "Apply to my plan",
            "not_now": "Not now",
            "what": "What does this do?",
            "the_activity": "The activity:",
            "signature_it_shows": "The signature it shows is {proposed}; your plan started from {current}.",
            "what_apply_does_a": "What",
            "what_apply_does_b": "does",
            "li1": "Rebuilds your predicted fitness from your training loads and the breakthroughs during this plan.",
            "li2": "Sets the signature at the start of your plan (on the first activity of the plan) to the predicted one, so your fitness follows the predicted trajectory through the plan.",
            "li3": "For a Focus Goal or a signature goal, moves your goal with it: the improvement you originally planned is added to the new start.",
            "li4": "Recalculates your fitness history from that activity. Some breakthroughs may no longer count as breakthroughs (those that fall on the predicted trajectory); activities you have flagged stay flagged.",
            "li5_a": "Until you apply it, your signature shows the breakthrough, as it does everywhere in Xert.",
            "li5_b": "leaves it that way.",
            "mode_on": "Predictive Mode is on.",
            "follows_from": "Your signature follows your plan's training loads from your first activity on {date}, with no decay, so it rises and falls with the plan.",
            "follows": "Your signature follows your plan's training loads, with no decay, so it rises and falls with the plan.",
            "notice_a": "If you have a breakthrough you will be asked whether to apply it to the plan. The decay method will return to",
            "notice_b": "when the plan ends.",
            "enabled": "Predictive Mode is now enabled.",
            "prompt": "Predictive Mode is on for Goal-based training plans. Your signature changes are predicted and when you have a breakthrough, you'll be asked whether to apply it to your whole plan.",
            "save_failed": "Your choice could not be saved. Try again.",
            "what_is": "What is Predictive Mode?",
            "ended_on": "Predictive Mode has ended for this plan. It will start with your next plan.",
            "ended_off": "Predictive Mode has ended for this plan and is off, so it will not start with your next plan either.",
            "turn_on_next": "Turn Predictive Mode on for my next plan",
            "managed_unavailable": "Not available while Predictive Mode manages your signature.",
            "disable": "Disable Predictive Mode",
            "continue": "Continue"
        },
        "page": {
            "load_failed": "The report could not be loaded.",
            "no_plan": "No plan in progress",
            "no_report_date": "No plan report for this date",
            "no_report": "No report for this plan",
            "create_plan": "Create a Forecast AI plan on the Program tab to see how it is going.",
            "none_on_date": "No plan runs on this date, or it ended more than two days before it.",
            "no_report_for_plan": "This plan does not have a report.",
            "back": "← Back to Program",
            "sections": "Report sections"
        },
        "tabs": {
            "overview": "Overview",
            "progress": "Your Progress",
            "execution": "Training Execution",
            "journey": "Forecast Journey",
            "versions": "Plan Versions"
        },
        "chart": {
            "actual": "Actual",
            "predicted": "Plan predicted",
            "breakthrough": "Breakthrough",
            "plan_updated": "Plan updated",
            "result": "Result",
            "target_date": "Target date {date}",
            "forecast": "Forecast",
            "original_target": "Original target",
            "adjusted_target": "Adjusted target",
            "reached": "What you reached"
        }
    }
}
